import { v4 as uuid } from 'uuid';

import { Model } from 'src/containers/ProjectDiagram/types/model';
import {
  CreateRelationshipMappingOptions,
  createRelationshipMapping,
} from 'src/containers/ProjectDiagram/utils/mapping/createRelationshipMapping';

export const addRelationshipMapping =
  ({
    from,
    fromClassIri,
    fromPrimaryIdentifier,
    relationshipIri,
    to,
    toClassIri,
    toPrimaryIdentifier,
    value = uuid(),
  }: CreateRelationshipMappingOptions) =>
  (model: Model) => {
    const newRelationshipMapping = createRelationshipMapping({
      from,
      fromClassIri,
      fromPrimaryIdentifier,
      to,
      toClassIri,
      toPrimaryIdentifier,
      relationshipIri,
      value,
    } as CreateRelationshipMappingOptions);

    model.addLinkData(newRelationshipMapping);

    return newRelationshipMapping;
  };
